/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
// import JsonQuery from 'json-query';
import { hooks as commonHooks, types as commonTypes } from '@sitebuilder/common';
import {
    getTextSchemaProperties,
    getStyleSchemaProperties,
    getLayoutSchemaProperties,
} from '../utils';
import tableStyles, { themeTableStyles } from './Table.styles';
import ExpandableRow from './ExpandableRow';

interface TableColumn {
    label?: string;
    value?: string;
    isOnlyText?: boolean;
}

export interface FundDistribution {
    companyName: string;
    percentage: number;
}

export interface FundData {
    fundName: string;
    fundAllocation: number;
    fundDistribution: FundDistribution[];
}

interface WidgetProperties extends commonTypes.WidgetPropertiesBase {
    columns?: TableColumn[];
    mockData?: FundData[];
    rows?: string;
    typographyClass?: string;
}

const ExpandableTable = (props: commonTypes.WidgetInstanceProps) => {
    // const { storyData } = props;
    const widgetProperties = commonHooks.useWidgetProperties<WidgetProperties>(
        props.widgetInstanceId
    );
    const { styles, columns } = widgetProperties || props;
    const data = props.data;
    const theme = data?.themeSelected || props?.theme;
    // const data = storyData || storeData;
    const rowsData = [
        {
            fundName: 'iShares Core S&P500 ETF',
            fundAllocation: 10.5,
            fundDistribution: [
                { companyName: 'Apple', percentage: 0.36 },
                { companyName: 'MICROSOFT CORP', percentage: 0.34 },
                { companyName: 'AMAZON COM INC', percentage: 0.25 },
                { companyName: 'FACEBOOK CLASS A INC', percentage: 0.14 },
                { companyName: 'Apple', percentage: 0.13 },
            ],
        },
        {
            fundName: 'Sun Life Granite Tactical Completion C-1',
            fundAllocation: 8.5,
            fundDistribution: [
                { companyName: 'Apple', percentage: 0.36 },
                { companyName: 'MICROSOFT CORP', percentage: 0.34 },
                { companyName: 'AMAZON COM INC', percentage: 0.25 },
                { companyName: 'FACEBOOK CLASS A INC', percentage: 0.14 },
                { companyName: 'Apple', percentage: 0.13 },
            ],
        },
    ];
    // JsonQuery(rows as string, { data }).value;
    return (
        <div
            className={widgetProperties?.typographyClass ? widgetProperties.typographyClass : ''}
            css={css`
                ${!theme ? tableStyles : themeTableStyles}${getTextSchemaProperties(
                    widgetProperties,
                    data?.colorSpace
                )}${getStyleSchemaProperties(widgetProperties)}${getLayoutSchemaProperties(
                    widgetProperties
                )}${styles || ''}
            `}
        >
            <table className={`table`}>
                <thead>
                    <tr>
                        {columns?.map((c: TableColumn, index: number) => (
                            <th key={index}>{c.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rowsData.map((r, index) => (
                        <ExpandableRow key={index} data={r} id={index} />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ExpandableTable;
